import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { COUNTER_PARTY } from './constants'
import { AchRelationshipResponsePayload } from '../types'
import queryKeys from './queryKeys'

const buildApiUrl = (accountNumber: string): string => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${COUNTER_PARTY}/ach_relationships?account=${accountNumber}`
}

export const useGetAchRel = (accountNumber: string) => {
  const getAchRelUrl = buildApiUrl(accountNumber)

  const getAchRel = async (): Promise<AchRelationshipResponsePayload[]> => {
    const { data } = await axios.get(getAchRelUrl, { withCredentials: true })
    return data as AchRelationshipResponsePayload[]
  }

  return useQuery<AchRelationshipResponsePayload[], AxiosError>([queryKeys.achRel, accountNumber], getAchRel, {
    // Will only execute on refetch
    enabled: false
  })
}
